import React from "react";
import {BaseComponent} from "@renta-apps/athenaeum-react-common";
import {Button, ButtonContainer, ButtonType, Modal, ModalSize} from "@renta-apps/athenaeum-react-components";
import Localizer from "@/localization/Localizer";

import styles from "./WorkOrderErrorModal.module.scss";

interface IWorkOrderErrorMessageModalProps {
}

interface IWorkOrderErrorMessageModalState {
    errorMessage: string;
    allowToContinue: boolean;
    onContinueHandler?: () => Promise<void>;
}

export default class WorkOrderErrorModal extends BaseComponent<IWorkOrderErrorMessageModalProps, IWorkOrderErrorMessageModalState> {

    state: IWorkOrderErrorMessageModalState = {
        errorMessage: "",
        allowToContinue: false,
    };

    private readonly _modalRef: React.RefObject<Modal> = React.createRef();

    private get modal(): Modal {
        return this._modalRef.current!;
    }

    public async openAsync(errorMessage: string, allowToContinue: boolean, onContinueHandler?: () => Promise<void>): Promise<void> {
        await this.setState({
            errorMessage,
            allowToContinue,
            onContinueHandler,
        });
        await this.modal.openAsync();
    }

    private async onClose(): Promise<void> {
        if (this._modalRef.current) {
            await this.modal.closeAsync();
        }
    }

    private async onContinue(): Promise<void> {
        if (this._modalRef.current) {
            await this.modal.closeAsync();
        }
        if (this.state.onContinueHandler && this.state.allowToContinue) {
            await this.state.onContinueHandler();
        }
    }

    public render(): React.ReactNode {
        return (
            <Modal id="errorModal"
                   ref={this._modalRef}
                   size={ModalSize.Large}
                   title={Localizer.errorPageTitle}
                   hideCloseButton={false}
                   onClose={async () => await this.onClose()}
            >
                {this.state.errorMessage && (
                    <p>{this.state.errorMessage}</p>
                )}

                <React.Fragment>
                    <ButtonContainer>
                        {
                            (this.state.allowToContinue) && (
                                <Button id="continueButton"
                                        className={styles.okButton}
                                        label={Localizer.genericOk}
                                        type={ButtonType.Blue}
                                        icon={{ name: "check" }}
                                        right={true}
                                        onClick={async () => await this.onContinue()}
                                />
                            )
                        }
                        <Button id="closeErrorModalButton"
                                label={Localizer.confirmationDialogClose}
                                type={ButtonType.Orange}
                                icon={{ name: "times" }}
                                right={true}
                                onClick={async () => await this.onClose()}
                        />
                    </ButtonContainer>
                </React.Fragment>
            </Modal>
        );
    }
}